import { RouterProvider } from "react-router-dom";
import { routes } from './router/route';
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "./redux/store";
import { useEffect, useState } from "react";
import { fetchBaseUrl, fetchUserInfo, updateLoginUserData, user } from "./redux/reducers/UserReducer";
import { toast } from "react-toastify";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginUser } from "./redux/reducers/profileReducer";
import { handleLogout } from "./msal/msal";
import { getAdEmailFromAccount } from "./msal/userHelper";



function App() {
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
  const tokens = useSelector((state: RootState) => state.profileReducer.token)
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const token = tokens || localStorage.getItem("token")
  const statusCode = useSelector((state: RootState) => state.profileReducer.statusCode)
  const dispatch = useDispatch<AppDispatch>()
  // const token = localStorage.getItem("token");
  const userData = useSelector(user);
  const roleOflogiUser = useSelector((state: RootState) => state.profileReducer.roleOflogiUser)
  const loginUserStatus = useSelector((state: RootState) => state.profileReducer.statusCode)

  const loginUserData = useSelector((state: RootState) => state.profileReducer.userData)

  const isAuthenticated = useIsAuthenticated()

  const { instance } = useMsal()

  const account = instance.getActiveAccount()

  useEffect(() => {
    if (isAuthenticated && !token) {
      dispatch(loginUser({ email: getAdEmailFromAccount(account) }))
    }
  }, [isAuthenticated]);

  useEffect(() => {
console.log("envvariable",process.env.REACT_APP_ENV)
    dispatch(loginUser({ email: getAdEmailFromAccount(account) }))
dispatch(fetchBaseUrl({
  env: process.env.REACT_APP_ENV!,
  id: process.env.REACT_APP_BASEID!,
}));

  }, [])

  useEffect(() => {
    const isRoleInvalid =
      roleOflogiUser === undefined ||
      roleOflogiUser === null ||
      roleOflogiUser === "null" ||
      (Array.isArray(roleOflogiUser) && roleOflogiUser.length === 0);

    if (loginUserStatus === 400 || loginUserStatus === 404 || isRoleInvalid) {
      handleLogout();
      setIsCheckingAuth(false);
    } else if (loginUserStatus === 200) {
      dispatch(updateLoginUserData(loginUserData));
      setIsCheckingAuth(false);
    }
  }, [loginUserStatus, roleOflogiUser]);

  useEffect(() => {
    // if(token)
    if (token && userData?.status === 401) {
      localStorage.removeItem("token")
      localStorage.removeItem("userroles")
      toast.dismiss()
      toast.error(userData.message);
      return;
    }
    if (token && userData?.status != 401 && userData?.status != 200) {
      axios.defaults.headers["authentication"] = token;
      dispatch(fetchUserInfo());
    }
  }, [userData]);

  if (isCheckingAuth) return null;

  return (
    <div>
      <RouterProvider router={routes} />
    </div>
  );
}

export default App;
